import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { HttpService } from '../services/http.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuardGuard implements CanActivate {
  constructor(private httpService: HttpService, private router: Router) {}
  canActivate(): boolean {
    if (this.httpService.isUserAuthorize) {
      return true;
    } else {
      this.router.navigate(['/login']);
      return false;
    }
  }
}
